import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { services } from "@/data/portfolio";
import { useState } from "react";

export default function Services() {
  const [open, setOpen] = useState(0);
  return (
    <section id="services" className="section services" data-testid="services-section">
      <header className="section__head">
        <span className="overline">◆ Services · what I do</span>
        <h2 className="section__title serif" data-testid="services-heading">
          Built to <span className="italic">earn clicks,</span> trust and time.
        </h2>
      </header>

      <ul className="services__list" data-testid="services-list">
        {services.map((s, i) => {
          const isOpen = open === i;
          return (
            <motion.li
              key={s.no}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className={`srow ${isOpen ? "srow--open" : ""}`}
              data-testid={`service-row-${s.no}`}
            >
              <button
                type="button"
                className="srow__head"
                aria-expanded={isOpen}
                aria-controls={`service-panel-${s.no}`}
                onClick={() => setOpen(isOpen ? -1 : i)}
                data-cursor={isOpen ? "close" : "open"}
                data-testid={`service-toggle-${s.no}`}
              >
                <span className="srow__no overline">{s.no}</span>
                <h3 className="srow__title serif">{s.title}</h3>
                <span className={`srow__icon ${isOpen ? "is-rotated" : ""}`}>
                  <Plus size={20} strokeWidth={1.4} />
                </span>
              </button>
              <div id={`service-panel-${s.no}`} hidden={!isOpen} className={`srow__body ${isOpen ? "is-open" : ""}`}>
                <p>{s.desc}</p>
                <ul className="srow__delivs">
                  {s.deliverables.map((d) => (
                    <li key={d}>— {d}</li>
                  ))}
                </ul>
              </div>
            </motion.li>
          );
        })}
      </ul>
    </section>
  );
}
